import { Button } from '@mui/material';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import { Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
interface ReactFinalFormProps {
  onSubmit: (values: any) => void;
  children: any;
  hideControls?: boolean;
  formId?: string;
  disableEdit?: boolean;
  edit?: boolean;
  initialValues?: any;
  keepDirtyOnReinitialize?: boolean;
}

/**
 * COMPONENTE
 * Wrapper component per React Final Form con UI controls preconfigurati
 *
 * param props -> Configurazione del componente
 * onSubmit - Funzione chiamata alla submission del form con i valori validati
 * children - Contenuto del form
 * hideControls - Se true, nasconde i pulsanti di controllo (Back, Submit)
 * formId - ID custom del form (default: generato automaticamente)
 * disableEdit - Se true, disabilita il pulsante di submit
 * edit - Modalità edit: cambia label submit da "Insert" a "Save"
 * initialValues - Valori iniziali per il form
 * keepDirtyOnReinitialize - Mantiene dirty state dopo re-initialization

 * ritorna Componente form con controlli UI
 */

export const ReactFinalWithInitialValuesForm: React.FC<ReactFinalFormProps> = ({
  onSubmit,
  children,
  hideControls,
  formId,
  disableEdit,
  edit,
  initialValues,
  keepDirtyOnReinitialize
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const FORM_ID = formId ?? `form-${dayjs().toISOString()}`;

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={initialValues}
      keepDirtyOnReinitialize={keepDirtyOnReinitialize}
      render={({ handleSubmit, submitting, pristine, invalid }) => {
        return (
          <form onSubmit={handleSubmit} id={FORM_ID}>
            <div id="ReactFinalDialogFormChildren">{children}</div>
            {!disableEdit && (
              <div className="flex justify-center my-3">
                <Button
                  form={FORM_ID}
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={submitting || pristine || invalid}>
                  {edit ? t('actions.save') : t('actions.insert')}
                </Button>
              </div>
            )}
          </form>
        );
      }}
    />
  );
};

ReactFinalWithInitialValuesForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  hideControls: PropTypes.bool,
  formId: PropTypes.string,
  disableEdit: PropTypes.bool,
  edit: PropTypes.bool,
  initialValues: PropTypes.object,
  keepDirtyOnReinitialize: PropTypes.bool
};
